import styled from "styled-components";
import { colors } from "utils";
import { useRemoteFlags } from "hooks/useFeatureFlag";

/**
 * Tells a superuser which feature flags the super-user override forced on for
 * them while they impersonate a teacher. Rendered only when the override
 * actually changed an answer, so a teacher, a client admin and a superuser on
 * their own account never see it: their override list is always empty.
 */
export const SuperuserPreviewLine = () => {
  const { superuserOverrides } = useRemoteFlags();

  if (superuserOverrides.length === 0) return null;

  const count = superuserOverrides.length;

  return (
    <Line title={superuserOverrides.join(", ")}>
      {`Superuser preview: ${count} ${count === 1 ? "flag" : "flags"}`}
    </Line>
  );
};

const Line = styled.div`
  padding: 6px 16px 0;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: ${colors.nightlyWoods700};
`;
